module.exports = __webpack_public_path__ + "img/icon-c-d-7.28458e97.png";